import './style.scss'

import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { capitalize } from 'utilities/text'
import { getDateAsText } from 'utilities/date'
import { withTranslation } from 'react-i18next'

class CartDeliverTo extends Component {
    getAddressString(address) {
        return `${capitalize(address.streetName)}
      ${address.streetNo}${address.entrance || ''}, ${address.zip} ${capitalize(address.city)}`
    }
    render() {
        const { address, date, t } = this.props
        return (
            <div
                className="cart-deliver-to-address"
                dangerouslySetInnerHTML={{
                    __html: t('cartCartDeliverTo', {
                        date: getDateAsText(date, true),
                        address: this.getAddressString(address),
                    }),
                }}
            />
        )
    }
}

CartDeliverTo.propTypes = {
    address: PropTypes.object.isRequired,
    date: PropTypes.string,
    t: PropTypes.func.isRequired,
}

export default withTranslation()(CartDeliverTo)
